<template>
  <footer id="contact" class="landing-footer py-12">
    <div class="container mx-auto px-4">
      <div class="flex flex-col md:flex-row md:items-start md:justify-between gap-10">
        <!-- Brand -->
        <div class="landing-footer-brand shrink-0">
          <AppLogo />
        </div>

        <!-- Link modules -->
        <div class="grid grid-cols-2 sm:grid-cols-3 gap-x-10 gap-y-8 md:flex-1 md:max-w-2xl md:ml-auto">
          <!-- Product -->
          <div>
            <h3 class="landing-footer-heading text-sm font-medium mb-4">
              {{ t('landing.footer.product.title') }}
            </h3>
            <ul class="space-y-3">
              <li>
                <a
                  href="https://photoscope.cc/"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="landing-footer-link"
                >
                  {{ t('landing.footer.product.photoscope') }}
                </a>
              </li>
              <li>
                <a
                  href="https://before-after.photoscope.cc/"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="landing-footer-link"
                >
                  {{ t('landing.footer.product.beforeAfter') }}
                </a>
              </li>
            </ul>
          </div>

          <!-- Resources -->
          <div>
            <h3 class="landing-footer-heading text-sm font-medium mb-4">
              {{ t('landing.footer.resources.title') }}
            </h3>
            <ul class="space-y-3">
              <li>
                <a
                  href="#pricing"
                  @click.prevent="scrollToSection('pricing')"
                  class="landing-footer-link"
                >
                  {{ t('landing.footer.resources.pricing') }}
                </a>
              </li>
              <li>
                <router-link :to="`/${$i18n.locale}/blog`" class="landing-footer-link">
                  {{ t('landing.footer.resources.blog') }}
                </router-link>
              </li>
            </ul>
          </div>

          <!-- Company -->
          <div>
            <h3 class="landing-footer-heading text-sm font-medium mb-4">
              {{ t('landing.footer.company.title') }}
            </h3>
            <ul class="space-y-3">
              <li>
                <a href="mailto:info@photoscope.cc" class="landing-footer-link">
                  {{ t('landing.footer.company.contact') }}
                </a>
              </li>
              <li>
                <router-link :to="`/${$i18n.locale}/terms`" class="landing-footer-link">
                  {{ t('landing.footer.company.terms') }}
                </router-link>
              </li>
              <li>
                <router-link :to="`/${$i18n.locale}/privacy`" class="landing-footer-link">
                  {{ t('landing.footer.company.privacy') }}
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="text-center mt-10">
        <p class="text-xs">{{ t('landing.footer.copyright') }}</p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import AppLogo from '../AppLogo.vue'

const { t } = useI18n()

// 与 LandingHeader.scrollToSection 一致：页内锚点平滑滚动，预留固定头部高度
const scrollToSection = (sectionId) => {
  const section = document.getElementById(sectionId)
  if (!section) return
  const headerOffset = 64
  const elementPosition = section.getBoundingClientRect().top
  const offsetPosition = elementPosition + window.pageYOffset - headerOffset
  window.scrollTo({ top: offsetPosition, behavior: 'smooth' })
}
</script>

<style scoped>
.landing-footer {
  background: var(--landing-section-bg);
  color: var(--text-muted);
}

.landing-footer-brand {
  margin-top: 0.25rem;
}

.landing-footer-heading {
  color: var(--text-secondary);
}

.landing-footer-link {
  color: var(--text-muted);
  font-size: 0.8125rem;
  transition: color 0.2s ease;
}

.landing-footer-link:hover {
  color: var(--theme-primary);
}
</style>
